import React from 'react';

import { Box } from 'native-base';
import { SafeAreaView } from 'react-native';

import { LayoutContainer } from 'components/layout/styled';
import LoadingAnimation from 'components/loading-animation';
import { Table } from 'components/table';
import { isNative } from 'utils/environment';
import { ITable } from 'utils/table';

import { TransactionTable, TransactionTableRow } from './types';

const Spinner = () => (
  <LayoutContainer>
    <Box padding="$2">
      <LoadingAnimation />
    </Box>
  </LayoutContainer>
);

export const HistoryLazyTableList = ({
  tables,
  visibleTransactions,
  handleOnPressRow,
  loadingMore,
}: {
  tables: TransactionTable[];
  visibleTransactions?: number;
  handleOnPressRow: (row: TransactionTableRow | Partial<TransactionTableRow>) => void;
  loadingMore?: boolean;
}) => {
  const renderItem = ({
    item,
    index,
  }: {
    item: ITable<Partial<TransactionTableRow>>;
    index: number;
  }) => (
    <Table<TransactionTableRow>
      key={`historyTable.${index}`}
      table={item}
      onPressRow={handleOnPressRow}
      marginTop="$4"
    />
  );

  // Lazy Loading only for Native...
  if (isNative && visibleTransactions) {
    return (
      <SafeAreaView style={{ flex: 1 }}>
        {tables.slice(0, visibleTransactions).map((item, index) => renderItem({ item, index }))}
        {loadingMore && <Spinner />}
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={{ flex: 1 }}>
      {tables.map((item, index) => renderItem({ item, index }))}
    </SafeAreaView>
  );
};
